import { Component, OnInit, OnDestroy, ViewEncapsulation, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ControlValidator } from 'src/app/core/helpers/control-validation.helper';
import { PaymentService } from 'src/app/core/services/payment.service';
import { Subject } from 'rxjs';
import { takeUntil, switchMap } from 'rxjs/operators';
import { Barcode, PrecheckoutResponse } from 'src/app/core/models/Barcode.model';
import { MessageService } from 'primeng/api';
import { FormControlHelpers } from 'src/app/core/helpers/form-control.helper';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None
})
export class PaymentComponent implements OnInit, OnDestroy {

  barcodeList: Barcode[] = [];
  destroyed$ = new Subject();
  form: FormGroup;
  barcodeMask = '00000.00000 00000.000000 00000.000000 0 00000000000000';
  amountTotal = 0;
  tableColumns: any[];
  precheckout: PrecheckoutResponse;
  addLoader: boolean;
  infoFormModal = false;
  infoForm: FormGroup;
  infoFormLoader: boolean;
  checkoutResponse: any;

  constructor(
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private paymentService: PaymentService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      barcode: [null, [Validators.required, ControlValidator.boletoValidation()]]
    });

    this.infoForm = this.formBuilder.group({
      name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      cpf: [null, Validators.required],
      phoneNumber: [null, Validators.required],
    });

    this.tableColumns = [
      { header: 'Linha digitável', type: 'BARCODE' },
      { header: 'Banco', type: 'BANK' },
      { header: 'Vencimento', type: 'DATE' },
      { header: 'Valor', type: 'AMOUNT' },
      { header: '', type: 'BUTTON' },
    ];
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  addPayment() {
    let duplicated = false;
    this.barcodeList.forEach(barcode => {
      if (this.form.value.barcode === barcode.barcode) {
        this.messageService.add({
          key: 'custom', severity: 'warn', summary: 'Atenção', detail: 'Boleto duplicado'
        });
        duplicated = true;
        this.form.reset();
      }
    });

    if (this.form.valid && !duplicated) {
      this.addLoader = true;
      this.paymentService.getBarcode(this.form.value.barcode)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((data: Barcode) => {
          this.addLoader = false;
          this.form.reset();
          this.barcodeList.push(data);
          this.amountTotal += data.amount.amount;
        }, error => {
          this.addLoader = false;
          if (error.error.statusCode === '404') {
            this.messageService.add({
              key: 'custom', severity: 'error', summary: 'Atenção', detail: error.error.message
            });
          } else {
            this.messageService.add({
              key: 'custom', severity: 'error', summary: 'Erro', detail: 'Erro no sistema, tente novamente.'
            });
          }
        });
    }
  }

  onRemovePayment(index: number, barcode: Barcode) {
    this.amountTotal -= barcode.amount.amount;
    this.barcodeList.splice(index, 1);
  }

  openModal() {
    if (Array.isArray(this.barcodeList) && this.barcodeList.length) {
      this.infoFormModal = true;
    } else {
      this.messageService.add({
        key: 'custom', severity: 'warn', summary: 'Atenção', detail: 'Adicione pelo menos um boleto para prosseguir.'
      });
    }
  }

  onCancel() {
    this.barcodeList = [];
    this.amountTotal = 0;
  }

  onSubmit() {
    FormControlHelpers.validateAllFields(this.infoForm);

    if (this.infoForm.valid) {
      this.infoFormLoader = true;
      const barcodeList = {
        barcodes: []
      };

      this.barcodeList.forEach(data => {
        barcodeList.barcodes.push(data.barcode);
      });

      this.paymentService.precheckout(barcodeList)
        .pipe(
          takeUntil(this.destroyed$),
          switchMap((response: PrecheckoutResponse) => {
            this.precheckout = response;
            return this.paymentService.getPagSeguroToken(this.infoForm.value, barcodeList);
          }))
        .subscribe((data) => {
          this.infoFormLoader = false;
          this.infoFormModal = false;
          this.lightbox(data.code);
        }, error => this.messageService.add({
          key: 'custom', severity: 'error', summary: 'Erro', detail: 'Erro no sistema, tente novamente.'
        }));
    }
  }

  lightbox(transactionCode) {
    const PagSeguroLightbox = window['PagSeguroLightbox'];
    PagSeguroLightbox(transactionCode, {
      success: token => this.ngZone.run(() => {
        this.paymentService.payment(token)
          .pipe(takeUntil(this.destroyed$))
          .subscribe(response => this.checkoutResponse = response,
            error => this.messageService.add({
              key: 'custom', severity: 'error', summary: 'Erro', detail: 'Erro no sistema, tente novamente.'
            }));
      }),
      abort: () => this.ngZone.run(() => console.log(false)),
      complete: complete => this.ngZone.run(() => console.log(complete, 'complete'))
    });
  }

}
